import { render, staticRenderFns } from "./PeriodsPricesDialog.vue?vue&type=template&id=663d52f8&scoped=true"
import script from "./PeriodsPricesDialog.vue?vue&type=script&lang=js"
export * from "./PeriodsPricesDialog.vue?vue&type=script&lang=js"
import style0 from "./PeriodsPricesDialog.vue?vue&type=style&index=0&id=663d52f8&prod&scoped=true&lang=css"
import style1 from "./PeriodsPricesDialog.vue?vue&type=style&index=1&id=663d52f8&prod&lang=css"
import style2 from "./PeriodsPricesDialog.vue?vue&type=style&index=2&id=663d52f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663d52f8",
  null
  
)

export default component.exports